const getDateTranslation = (date, t, { showWeek = true } = {}) => {
  const [week, day, month] = date.split(' ');

  return `${showWeek ? `${t(`_${week}_`)}, ` : ''}${day} ${t(`_${month}_`)}`;
};

export default getDateTranslation;
